import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'
import { PerPageOption } from './components/Pagination'
export interface PaginationState {
  currentPage: number
  setCurrentPage: (page: number) => void
  perPage: PerPageOption
  setPerPage: (perPage: PerPageOption) => void
  search: string
  onSearchChange: (search: string) => void
  debouncedSearch: string
}

function usePagination(initialPerPage: PerPageOption = 10): PaginationState {
  const [currentPage, setCurrentPage] = useState(1)
  const [perPage, setPerPage] = useState(initialPerPage)
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 500)

  function onSearchChange(value: string) {
    setSearch(value)
    setCurrentPage(1)
  }

  function onPerPageChange(newPerPage: PerPageOption) {
    setCurrentPage(1)
    setPerPage(newPerPage)
  }

  return {
    currentPage,
    setCurrentPage,
    perPage,
    setPerPage: onPerPageChange,
    debouncedSearch,
    search,
    onSearchChange,
  }
}

export { usePagination }
